import { render, staticRenderFns } from "./TiposBemMultipleSelect.vue?vue&type=template&id=a09a51ca&"
import script from "./TiposBemMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./TiposBemMultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports